const utils = {
    // 格式化金额
    formatAmount: (amount) => {
        let num = Number(amount)
        if (!num || isNaN(num)) num = 0
        num = Math.round(num * 100) / 100
        const symbol = num < 0 ? '-' : ''

        // 将数值转为字符串
        const numStr = `${Math.abs(num)}`

        let [integer, decimals] = numStr.split('.')
        if (!decimals) decimals = "00"
        else if (decimals.length == 1) decimals = `${decimals}0`

        // 对整数部分进行格式化
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return `Rp ${symbol}${integer}.${decimals}`
    },
    // 获取设备系统信息
    getDetectOS: () => {
        const ua = navigator.userAgent || '';
        const platform = navigator.platform || '';
        const maxTouchPoints = navigator.maxTouchPoints || 0;
        console.log(ua);
        console.log(platform);
        console.log(maxTouchPoints);

        const isAndroid = /Android/i.test(ua);
        const isIPhone = /iPhone/i.test(ua);
        const isIPad = /iPad/i.test(ua)
            || (navigator.userAgentData?.platform === 'iPad') // 少见
            || (/Mac/i.test(platform) && maxTouchPoints > 1); // iPadOS 13+

        const isMac = /Mac/i.test(platform) && !isIPad;
        const isWindows = /Win/i.test(platform);

        if (isAndroid) return 'Android';
        if (isIPhone) return 'iPhone';
        if (isIPad) return 'iPad';         // 如不需要，可并入 iPhone
        if (isMac) return 'macOS';
        if (isWindows) return 'Windows';
        return 'Other';
    },
    // 格式化时间
    formatTmie: (timestamp = '', date) => {
        if (!timestamp) timestamp = new Date()
        // 接口返回的是秒数，需要转为毫秒数
        else timestamp = new Date(timestamp * 1000)

        const year = timestamp.getFullYear();
        const month = String(timestamp.getMonth() + 1).padStart(2, '0');
        const day = String(timestamp.getDate()).padStart(2, '0');
        const hours = String(timestamp.getHours()).padStart(2, '0');
        const minutes = String(timestamp.getMinutes()).padStart(2, '0');
        const seconds = String(timestamp.getSeconds()).padStart(2, '0');

        if (date) return `${year}-${month}-${day}`;
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
}

const detectOS = utils.getDetectOS()

export default { ...utils, detectOS }